import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primary", "confirm", "warning", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    const primary = this.primaryTarget.value
    const confirm = this.confirmTarget.value
    const match = primary !== "" && primary === confirm
    const mismatch = confirm !== "" && !match

    this.confirmTarget.style.borderColor = mismatch ? "red" : ""
    this.warningTarget.hidden = !mismatch
    this.submitTarget.disabled = !match
  }

  preventPaste(event) {
    event.preventDefault()
  }
}
